<template>
  <section
    ref="productCtaContainer"
    class="product-images-cta-container"
  >
    <component
      :is="item.url ? 'a' : 'button'"
      v-for="(item, itemIndex) in sortedList"
      v-bind="item.url ? { href: item.url, target: item.allowOpeningInNewTab ? '_blank' : '_self', } : {}"
      :key="`cta_item_${item.id || itemIndex}`"
      :class="['cta-item', { 'with-arrow-icon': item.showArrow }, item.customCssClass || '']"
      :style="item.customStyle || null"
      :rel="item.isAR && 'ar'"
      :aria-label="item.label.split('<br>')[0].toLowerCase()"
      @click="item.onClickHandler"
    >
      <img
        v-if="item.isAR"
        src=""
        class="empty-image"
      >
      <span
        :class="[{'cta-item--label': !item.customLabelClass}, item.customLabelClass || '']"
        v-html="item.label"
      />
      <span
        v-if="item.showArrow"
        :class="['cta-item--arrow-icon', {'chevron-medium-down-black': !item.customArrowClass}, item.customArrowClass || '']"
      />
    </component>
  </section>
</template>

<script setup>
import { ref } from 'vue';
import { useProductImagesCta } from '../composables/useProductImagesCta/useProductImagesCta';

const props = defineProps({
  productId: {
    type: String,
    required: true,
  },
});

const productCtaContainer = ref(null);

const { sortedList } = useProductImagesCta(props.productId, productCtaContainer);
</script>
<style lang="scss" scoped>
@keyframes product-images-cta-container-fade {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
.product-images-cta-container {
  position: absolute;
  top: rem-calc(16);
  left: rem-calc(16);
  opacity: 0;
  z-index: 10;

  animation-name: product-images-cta-container-fade;
  animation-delay: 0.1s;
  animation-fill-mode: forwards;
  animation-duration: 0.5s;

  .cta-item {
    align-items: center;
    background-color: $black;
    border: none;
    border-radius: 50%;
    color: $white;
    cursor: pointer;
    display: flex;
    flex-direction: column;
    font-size: rem-calc(9);
    font-weight: bold;
    height: rem-calc(70);
    justify-content: center;
    letter-spacing: 0.05em;
    line-height: rem-calc(12);
    padding: 0;
    text-align: center;
    text-decoration: none;
    text-transform: uppercase;
    width: rem-calc(70);

    &:not(:last-child) {
      margin: rem-calc(0 0 16);
    }

    &.font-small {
      font-size: 8px;
      line-height: rem-calc(12);
    }
    &.font-big {
      font-size: 10px;
      line-height: rem-calc(14);
      padding: 0 rem-calc(12);
    }

    &.with-arrow-icon {
      padding: rem-calc(12) rem-calc(10) 0;
    }

    .chevron-medium-down-black {
        filter: invert(1);
    }

    &--arrow-icon {
      margin-top: rem-calc(-3);
    }
  }
  .empty-image {
    height: 0;
    width: 0;
    border: none;
    outline: none;
  }
}
</style>
